import { esEstatusCancelado } from './policyStatuses.js';

// Que cuenta como poliza VIVA y que como cancelada.
//
// Lissette, 2026-08-21: "en la lista me esta mostrando todas las polizas,
// tanto cancelada como activa; solo quiero que muestres las activas".
//
// El fallo era concreto: las etiquetas de aseguradora de cada fila de la lista
// de clientes NO filtraban nada. Un cliente con una poliza de Florida Blue
// cancelada seguia enseñando "Florida Blue" como si estuviera al dia, al lado
// de las vivas y sin nada que las distinguiera.
//
// Los iconos de tipo que van justo al lado SI filtraban, y ese desajuste es lo
// que hacia el fallo dificil de creer: en la misma fila, una parte escondia
// las canceladas y la otra no.
//
// LO QUE HAY QUE SABER ANTES DE TOCAR ESTO:
//
// Con datos del servidor, `cancelled` es el UNICO valor de baja que llega:
// STATUS_BACK_TO_FRONT (crm-app/policyStatuses.js) convierte CANCELLED,
// LAPSED, EXPIRED e INACTIVE a 'cancelled'. Por eso los sitios que filtran
// solo por `status!=="cancelled"` son correctos en produccion, aunque parezcan
// incompletos.
//
// `inactive` se conserva aqui porque si aparece fuera de esa via: en los datos
// de la demo, en modo local y en filas viejas. Es red de seguridad, no la
// regla principal.
//
// Y lo que NO entra: una poliza "pending", "grace" o con un estado propio de
// la agencia que describa un TRAMITE ("Sometida", "Kit enviado", "Pendiente de
// cancelar") NO esta cancelada — esta en camino, y son justo las que hay que
// atender. Esconderlas seria peor que el fallo original (Lissette 2026-06-23:
// "me sale solo una y tengo 2", cuando se filtro por status==="active" y
// desaparecieron las pendientes).
//
// La unica excepcion, desde el 2026-09-15: un estatus propio de la agencia que
// se LLAMA "Cancelada" (o Baja, o Anulada) si cuenta. No es adivinar: es leer
// lo que la agencia escribio. La regla y sus dos listas —las palabras que son
// baja y las que solo la anuncian— viven en policyStatuses.js#esNombreDeBaja.

const DE_BAJA = ['cancelled', 'inactive', 'lapsed', 'expired'];

export function esPolizaCancelada(p) {
  if (!p) return false;
  // Bandera suelta que traen algunas filas (p. ej. las de Pagos del Mes).
  if (p.cancelled === true) return true;
  if (DE_BAJA.includes(String(p.status || '').trim().toLowerCase())) return true;
  // ...y el estatus PROPIO de la agencia que se llama "Cancelada". Su id es un
  // `cs_...` que no esta en la lista de arriba y el enum del servidor lo deja
  // en ACTIVE a proposito, asi que sin esto una cartera entera importada como
  // cancelada seguia saliendo en Activas (Denisse, 2026-09-15). La regla es la
  // misma que usa Comisiones por Poliza: vive en policyStatuses.js.
  return esEstatusCancelado(p.status);
}

// Las que se enseñan. Devuelve SIEMPRE un array, aunque le llegue basura:
// quien lo pinta hace `.map` sin preguntar.
export function polizasVivas(lista) {
  return (Array.isArray(lista) ? lista : []).filter((p) => !esPolizaCancelada(p));
}

// Las aseguradoras de las polizas vivas, sin repetir y en el orden en que
// aparecen. Es lo que sale como etiquetas en cada fila de la lista de clientes.
export function aseguradorasVivas(lista) {
  return [...new Set(polizasVivas(lista).map((p) => p && p.carrier).filter(Boolean))];
}
